// import InputGroup from "../../../../components/FormComponent/InputGroup";
import Layout from "../../../../components/Layout";
import BreadCrumb from "../../../../components/BreadCrumb";
import { toast } from "react-toastify";
import Button from "../../../../components/Button";
import useStyles from "../../styles";
import PaymentCard from "../../../../components/CardCount/PaymentCard";
import { TableSearch } from "../../../../components/Table/TableActions";
import Table from "../../../../components/Table/Table";
import Modal from "../../../../components/Modal";
import { Icon } from "@iconify/react/dist/iconify.js";
import PaymentRow from "./PaymentRow";
import Badge from "../../../../components/Badge";
import {
  Table as GridTable,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Paper,
  Grid
} from "@mui/material";
// import { useUserState } from "../../../../context/UserContext";
// import logo from "../../../../assets/images/logo.svg";
// import PaymentRow from "./PaymentRow";
import { useParams, useNavigate } from "react-router-dom";
import { httprequest } from "../../../../data/api";
import { useEffect, useState } from "react";
import PageLoader from "../../../../components/PageLoader";
import useWindowSize from "../../../../hooks/useWindow";
import { PaymentMethod } from "../../../../utils/DropDown";
import SelectGroup from "../../../../components/FormComponent/SelectGroup";
import InputGroup from "../../../../components/FormComponent/InputGroup";
import useValidator from "../../../../hooks/useValidator";

// const ALL_INVOICES = "/api/v1/invoice";
const STUDENT_INVOICE_DETAILS = "/api/v1/invoices/student-invoices/";
const UPLOAD_ENDPOINT = "/api/v1/upload";
const OFFLINE_PAYMENT = "/api/v1/invoices/student-invoices/";
const AUDIT_TRANSACTION = "/api/v1/invoices/student-invoices/transactions/";
// const STUDENT_INVOICE = "/api/v1/student-invoice";

const PreviewInvoice = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const classes = useStyles();
  const [cancelModal, setCancelModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingDecision, setLoadingDecision] = useState(null);
  const [addTransactionIsLoading, setAddTransactionIsLoading] = useState(false);
  const [invoice, setInvoice] = useState({});
  const [studentinvoice, setStudentsInvoice] = useState([]);
  const [searchResult, setSearchResult] = useState([]);
  const [auditTransaction, setAuditTransaction] = useState([]);
  const [searchAuditTransaction, setSearchAuditTransaction] = useState([]);
  const [appoveModal, setApproveModal] = useState(false);
  const [addTransactionValidator, showAddTransactionValidator] = useValidator();
  const [paymentDetails, setPaymentDetails] = useState(false);
  const [approveItems, setApproveItems] = useState({});
  // const [uploadForm, setUploadForm] = useState({});
  const [selectedFile, setSelectedFile] = useState([]);
  const [addTransactionModal, setAddTransactionModal] = useState(false);
  const width = useWindowSize();
  const mobile = width < 600;
  const [comment, setComment] = useState({
    comment: ""
  });

  const handleCommentChange = (e) => {
    const { name, value } = e.target;
    setComment({ ...comment, [name]: value });
  };

  const [addTransaction, setAddTransaction] = useState({
    amount: 0,
    reference: "",
    payment_method: "",
    description: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAddTransaction({ ...addTransaction, [name]: value });
  };

  /**
 * Fetches class invoices for all students
 * @function getStudentClassInvoice
 * @async
 * @description Retrieves invoice data for a class including student list and sets loading state
 * @throws {Error} Silently handles errors and stops loading indicator
 */
  const getStudentClassInvoice = () => {
    setIsLoading(true);
    httprequest
      .get(`${STUDENT_INVOICE_DETAILS}${id}`)
      .then((res) => {
        setInvoice(res?.data?.data);
        setStudentsInvoice(res?.data?.data?.transactions);
        setSearchResult(res?.data?.data?.transactions);
        setAuditTransaction(res?.data?.data?.transaction_audits);
        setSearchAuditTransaction(res?.data?.data?.transaction_audits);
        setIsLoading(false);
      }).catch(() => {
        setIsLoading(false);
      });
  };

  const handleCloseAddTransactionModal = () => {
    setAddTransactionModal(false);
    setAddTransaction({
      amount: 0,
      payment_method: "",
      description: ""
    });
    setSelectedFile([]);
  };

  const handleTransactionModal = () => {
    setAddTransactionModal(!addTransactionModal);
  };

  /**
 * Fetches a specific student's invoice details
 * @function getStudentInvoice
 * @async
 * @param {string} invoice_no - The invoice number to fetch
 * @description Retrieves detailed invoice data for a specific student
 * @throws {Error} Silently handles errors and stops loading indicator
 */
  // const getStudentInvoice = (invoice_no) => {
  //   setIsStudentInvoiceLoading(true);
  //   httprequest
  //     .get(`${STUDENT_INVOICE}/${invoice_no}`)
  //     .then((res) => {
  //       setAStudentInvoice(res?.data?.data);
  //       setIsStudentInvoiceLoading(false);
  //     }).catch(() => {
  //       setIsStudentInvoiceLoading(false);
  //     });
  // };

  /**
 * Closes cancel modal and navigates back to invoices page
 * @function handleCloseCancelModal
 */
  const handleCloseCancelModal = () => {
    setCancelModal(false);
    navigate("/payment/invoice");
  };

  /**
 * Toggles invoice modal and fetches student invoice data
 * @function handleInvoiceModal
 * @param {Object} row - The invoice row data containing invoice_no
 */
  // const handleInvoiceModal = (row) => {
  //   getStudentInvoice(row?.invoice_no);
  //   setInvoiceModal(!invoiceModal);
  // };

  /**
 * Closes the invoice detail modal
 * @function handleCloseInvoiceModal
 */
  // const handleCloseInvoiceModal = () => {
  //   setInvoiceModal(false);
  // };

  const handleApproveModal = (row) => {
    setApproveItems(row);
    setApproveModal(!appoveModal);
  };

  const handlePaymentDetails = (row) => {
    setPaymentDetails(!paymentDetails);
    setApproveItems(row);
  };

  // This function handles the file change when creating a transaction
  // FOR FILE UPLOAD
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const filesArray = Array.from(e.target.files);
      setSelectedFile(filesArray);
    }
  };

  const handleRemoveFile = (indexToRemove) => {
    const filtered = selectedFile.filter((_, i) => i !== indexToRemove);
    setSelectedFile(filtered);
  };

  /**
 * Table columns configuration for student invoices
 * @type {Array<Object>} columns
 * @property {string} name - Column header text
 * @property {Function} selector|cell - Cell content renderer
 * @property {boolean} [center] - Center align content
 * @property {boolean} [sortable] - Enable/disable sorting
 */
  const columns = [
    {
      name: "Payer Name",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Payer Name</p>}
          {`${row?.payer?.last_name || "--/--"} ${row?.payer?.first_name || "--/--"}`}
        </>
      )
    },
    {
      name: "Payment Method",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Payment Method</p>}
          {`${row?.payment_method || "--/--"}`}
        </>
      )
    },
    {
      name: "Amount",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Amount</p>}
          {row?.amount}
        </>
      )
    },
    {
      name: "Status",
      center: true,
      cell: (row) => <Badge status={row?.status} />
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        (row?.payment_method === "Payment link" || row?.status === "approved") ? (
          <>
            <button onClick={() => handlePaymentDetails(row)} className="table-action-icon">
              <Icon icon="fluent:eye-16-regular" />
            </button>
          </>
        ) : (
          <div key={row?.id} className="table-action-container">
            <button className="table-action-icon" onClick={() => handleApproveModal(row)}>
              <Icon icon="octicon:person-16" />
            </button>
            {/* <button className="table-action-icon delete-icon">
              <Icon icon="iconoir:telegram" />
            </button> */}
          </div>
        )
      )
    }
  ];
  /**
 * Table columns configuration for student invoices
 * @type {Array<Object>} columns
 * @property {string} name - Column header text
 * @property {Function} selector|cell - Cell content renderer
 * @property {boolean} [center] - Center align content
 * @property {boolean} [sortable] - Enable/disable sorting
 */
  const auditColumns = [
    {
      name: "Operated By",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Operated By</p>}
          {`${row?.operated_by?.last_name || "--/--"} ${row?.operated_by?.first_name || "--/--"}`}
        </>
      )
    },
    {
      name: "Event",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Event</p>}
          {`${row?.event || "--/--"}`}
        </>
      )
    },
    {
      name: "Comment",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Comment</p>}
          {row?.comment || "--/--"}
        </>
      )
    },
    {
      name: "Created At",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Created At</p>}
          {row?.created_at?.substring(0, 10) || "--/--"}
        </>
      )
    }
  ];

  //   Handle Create Transaction
  const handleCreateTransaction = async () => {
    if (!addTransactionValidator.allValid()) {
      showAddTransactionValidator(true);

      return;
    }

    setAddTransactionIsLoading(true);

    try {
      let uploadData = {};

      // Handle file upload if there's a selected file
      if (selectedFile?.length > 0) {
        const formData = new FormData();

        selectedFile.forEach((file) => {
          formData.append("file", file);
        });

        const response = await httprequest.post(`${UPLOAD_ENDPOINT}`, formData);

        if (response?.status === 200 && response?.data?.data) {
          const uploadedImages = response?.data?.data.map((file) => ({
            upload_id: file?.upload_id,
            file_url: file?.file_url
          }));
          uploadData = { receipts: uploadedImages };
        }
      }
      // ready final data object for post
      const data = { ...addTransaction, ...uploadData };

      // Submit the notice data
      const transactionresponse = await httprequest.post(`${OFFLINE_PAYMENT}${id}/transactions`, data);

      toast.success(transactionresponse?.data?.message);
      getStudentClassInvoice();
      handleCloseAddTransactionModal();
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setAddTransactionIsLoading(false);
    }
  };

  const handleTransactionDecision = (dec) => {
    setLoadingDecision(dec);

    const payload = {
      decision: dec,
      comment: comment?.comment
    };

    httprequest
      .post(`${AUDIT_TRANSACTION}${approveItems?.id}/audits`, payload)
      .then((res) => {
        toast.success(res?.data?.message);
        getStudentClassInvoice();
        handleApproveModal();
        setLoadingDecision(null);
      })
      .catch((error) => {
        setLoadingDecision(null);
        toast.error(error?.response?.data?.message);
      });
  };

  /**
 * Fetches class invoices on component mount
 * @effect
 * @listens Mount
 */
  useEffect(() => {
    getStudentClassInvoice();
  }, []);

  /**
 * Handles student invoice search functionality
 * @function handleSearchStudentInvoice
 * @param {Object} e - The input change event
 * @description Filters invoices based on multiple search terms across various fields
 */
  const handleSearchStudentInvoice = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = studentinvoice?.filter((data) => valArray?.every(
      (word) => data?.payer?.last_name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                            data?.payer?.first_name
                              ?.toLowerCase()
                              .includes(word.toLowerCase()) ||
                            data?.status
                              ?.toLowerCase()
                              .includes(word.toLowerCase()) ||
                              data?.payment_method
                                ?.toLowerCase()
                                .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };
  /**
 * Handles student invoice search functionality
 * @function handleSearchStudentInvoice
 * @param {Object} e - The input change event
 * @description Filters invoices based on multiple search terms across various fields
 */
  const handleSearchAuditTransaction = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = auditTransaction?.filter((data) => valArray?.every(
      (word) => data?.operated_by?.last_name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                            data?.operated_by?.first_name
                              ?.toLowerCase()
                              .includes(word.toLowerCase()) ||
                            data?.comment
                              ?.toLowerCase()
                              .includes(word.toLowerCase()) ||
                              data?.event
                                ?.toLowerCase()
                                .includes(word.toLowerCase())
    )
    );
    setSearchAuditTransaction(result);
  };

  // const total = payments.reduce((sum, payment) => sum + payment?.amount, 0);

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            <div>
              <BreadCrumb
                link_one="/payment/overview"
                link_one_name="Payments"
                link_two="/payment/invoice"
                link_two_name="Invoice"
                active={`${invoice?.student?.last_name} ${invoice?.student?.first_name} Invoice` || "--/--"}
                description="Preview your invoice before sending"
              />
            </div>
            <div className="flex gap-10">
              <Button
                variant="primary"
                buttonSize="fluid"
                color="btndefault"
                onClick={handleTransactionModal}
                buttonName="Add Transacction"
              />
            </div>
          </div>
          <div>
            {isLoading ? <PageLoader /> : (
              <>
                {/* <div className={classes.previewheader}>
                  <div className={classes.logoContent}>
                    <img
                      src={appLogo || logo}
                      alt="App Logo"
                      className={classes.logoContent}
                    />
                  </div>
                  <div>
                    <p>Invoice Number</p>
                    <h4>#{invoice?.invoice_number || "--/--"}</h4>
                  </div>
                </div> */}
                <div className="page-content padding-equal margin-bottom-14">
                  <Grid container spacing={3}>
                    <Grid item lg={4} md={6} sm={6} xs={12}>
                      <PaymentCard
                        title="Amount Paid"
                        count={invoice?.amount_paid?.toLocaleString() || 0}
                        icon={<Icon icon="hugeicons:sent" width="20" height="20" />}
                      />
                    </Grid>
                    <Grid item lg={4} md={6} sm={6} xs={12}>
                      <PaymentCard
                        title="Outstanding"
                        count={invoice?.outstanding?.toLocaleString() || 0}
                        icon={<Icon icon="mdi:credit-card-check" width="20" height="20" />}
                      />
                    </Grid>
                    <Grid item lg={4} md={6} sm={6} xs={12}>
                      <PaymentCard
                        title="Overpayment"
                        count={invoice?.overpayment?.toLocaleString() || 0}
                        icon={<Icon icon="mdi:credit-card-remove" width="20" height="20" />}
                      />
                    </Grid>
                  </Grid>
                </div>
                <div className="page-content padding-equal margin-bottom-14">
                  <div className="flex justify-content-between">
                    <div className={classes.intro}>
                      <h4>
                        Invoice Details
                      </h4>
                      <p>
                        See all information in your invoice
                      </p>
                    </div>
                    <div className={classes.paymentContainer}>
                      {/* Payment Status Badge */}
                      <div className={`${classes.paymentBadge} ${
                        invoice?.status === "paid" ? classes.paid :
                          invoice?.status === "partly_paid" ? classes.partlyPaid :
                            invoice?.status === "overpayment" ? classes.overpaid :
                              classes.unpaid
                      }`}
                      >
                        <span className={classes.badgeIcon}>
                          {invoice?.status === "paid" ? "✓" :
                            invoice?.status === "partly_paid" ? "◔" :
                              invoice?.status === "overpayment" ? "⤴" :
                                "!"}
                        </span>
                        {invoice?.status === "paid" ? "Paid" :
                          invoice?.status === "partly_paid" ? "Partly Paid" :
                            invoice?.status === "overpayment" ? "Overpaid" :
                              "Unpaid"}
                      </div>
                      <div className={classes.introright}>
                        <h4>Invoice Number</h4>
                        <p>#{invoice?.invoice_no || "--/--"}</p>
                      </div>
                    </div>
                  </div>
                  <div className={`${classes.previewheader} margin-bottom`}>
                    <div>
                      <p className="text-align-left">Invoice Name</p>
                      <h4>{invoice?.invoice_name || "--/--"}</h4>
                    </div>
                    <div className="text-align-right">
                      <p className="text-align-left-413">Amount</p>
                      <h3>{`${invoice?.currency || "NGN"} ${invoice?.total?.toLocaleString() || 0}`}</h3>
                    </div>
                  </div>
                  <Grid container spacing={2}>
                    <Grid item lg={2} md={4} sm={4} xs={6}>
                      <div className={`${classes.previewsubheader} text-align-left`}>
                        <div>
                          <p>Session</p>
                          <h4>{invoice?.session?.name || "--/--"}</h4>
                        </div>
                      </div>
                    </Grid>
                    <Grid item lg={2} md={4} sm={4} xs={6}>
                      <div className={`${classes.previewsubheader} text-align-left`}>
                        <div>
                          <p>Term</p>
                          <h4>{invoice?.term?.name || "--/--"}</h4>
                        </div>
                      </div>
                    </Grid>
                    <Grid item lg={2} md={4} sm={4} xs={6}>
                      <div className={`${classes.previewsubheader} text-align-left`}>
                        <div>
                          <p>For</p>
                          <h4>{invoice?.structure_type || "--/--"}</h4>
                        </div>
                      </div>
                    </Grid>
                    <Grid item lg={2} md={4} sm={4} xs={12}>
                      <div className={`${classes.previewsubheader} text-align-left`}>
                        <div>
                          <p>Invited To</p>
                          {/* <h4 className="text-align-left">
                            {invoice?.structure_type === "student" ? (
                              invoice?.students?.map((all, i) => {
                                return (
                                  <h4 className="key-pair-value text-align-left" key={i}>{`${all?.student?.last_name || "--/--"} ${all?.student?.first_name || "--/--"}`}</h4>
                                );
                              })
                            ) : invoice?.structure_type === "subject" ? (
                              <>
                                {invoice?.subject?.name || "--/--"}
                              </>
                            ) : invoice?.structure_type === "class" ? (
                              invoice?.classes?.map((all, i) => {
                                return (
                                  <h4 className="key-pair-value text-align-left" key={i}>{`${all?.name || "--/--"}`}</h4>
                                );
                              })
                            ) : null}
                          </h4> */}
                          <h4>{invoice?.student?.last_name} {invoice?.student?.first_name}</h4>
                        </div>
                      </div>
                    </Grid>
                    <Grid item lg={2} md={4} sm={4} xs={12}>
                      <div className={`${classes.previewsubheader} text-align-left`}>
                        <div>
                          <p>Created On</p>
                          <h4>{invoice?.created_at || "--/--"}</h4>
                        </div>
                      </div>
                    </Grid>
                    <Grid item lg={2} md={4} sm={4} xs={12}>
                      <div className={`${classes.previewsubheader} text-align-left`}>
                        <div>
                          <p>Due On</p>
                          <h4>{invoice?.due_date || "--/--"}</h4>
                        </div>
                      </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <div className={`${classes.previewsubheader} text-align-left`}>
                        <div>
                          <p>Online Payement Method</p>
                          <h4>{invoice?.online_payment_method?.provider || "--/--"}</h4>
                        </div>
                      </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <div className={`${classes.previewsubheader} text-align-left`}>
                        <div>
                          <p>Offline Payement Method</p>
                          <h4 className={classes.paymentMethod}>
                            {invoice?.offline_payment_methods?.length > 0
                              ? invoice?.offline_payment_methods
                                .map(payment => `${payment?.bank_name?.toUpperCase()} - ${payment?.account_number}`)
                                .join(" | ")
                              : "--/--"
                            }
                          </h4>
                        </div>
                      </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <div className={`${classes.previewsubheader} text-align-left`}>
                        <div>
                          <p>Discount</p>
                          <h4>{invoice?.discount ? `${invoice?.discount?.name} - ${invoice?.discount?.value}%` : "None"}</h4>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                  <div className={classes.schoolInfo}>
                    <div className={classes.infoRow}>
                      <span className={classes.label}>School Name:</span>
                      <span className={classes.value}>{invoice?.school?.name || "--/--"}</span>
                    </div>
                    <div className={classes.infoRow}>
                      <span className={classes.label}>Email:</span>
                      <span className={classes.value}>{invoice?.school?.email || "--/--"}</span>
                    </div>
                    <div className={classes.infoRow}>
                      <span className={classes.label}>Phone:</span>
                      <span className={classes.value}>{invoice?.school?.phone || "--/--"}</span>
                    </div>
                    <div className={classes.infoRow}>
                      <span className={classes.label}>Address:</span>
                      <span className={classes.value}>{invoice?.school?.address || "--/--"}</span>
                    </div>
                  </div>
                </div>
                <div className="page-content padding-equal margin-bottom-14">
                  <TableContainer component={Paper} style={{ overflowX: "auto" }} className="payment-table">
                    <GridTable>
                      <TableHead>
                        <TableRow>
                          <TableCell>Item</TableCell>
                          <TableCell>Payment Method</TableCell>
                          <TableCell>Amount</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody style={{ textAlign: "left" }}>
                        {invoice?.fee_items?.map((payment, index) => (
                          <PaymentRow
                            key={index}
                            item={payment?.item || "--/--"}
                            paymentMethods={invoice?.payment_method}
                            amount={payment?.amount}
                            ItemCurrency={invoice?.payment_method || "NGN"}
                          />
                        ))}
                      </TableBody>
                      <TableFooter style={{ backgroundColor: "#F9FAFB" }}>
                        <TableRow>
                          <TableCell colSpan={2} style={{ textAlign: "left", fontWeight: "700", fontSize: "14px", padding: "24px" }}>
      Total
                          </TableCell>
                          <TableCell style={{ textAlign: "right", fontWeight: "400", fontSize: "14px", padding: "24px" }}>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "4px" }}>
                              <div>Sub Total: <strong>{`${invoice?.currency || "NGN"} ${invoice?.total?.toLocaleString() || 0.00}`}</strong></div>
                              <div>Discount: <strong>{`${invoice?.currency || "NGN"} ${invoice?.discount_value?.toLocaleString() || 0.00}`}</strong></div>
                              <div style={{ fontSize: "18px", borderTop: "1px solid #E5E7EB", paddingTop: "8px", marginTop: "4px" }}>
          Grand Total: <strong>{`${invoice?.currency || "NGN"} ${invoice?.amount_payable?.toLocaleString() || 0.00}`}</strong>
                              </div>
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableFooter>
                    </GridTable>
                  </TableContainer>
                </div>
                <div className="page-content padding-equal margin-bottom-14">
                  <div className={classes.intro}>
                    <h4>
                        Payment History
                    </h4>
                  </div>
                  <Table data={searchResult} columns={columns} subHeader={true} pagination isLoading={isLoading} subHeaderComponent={
                    studentinvoice?.length > 0 && (
                      <TableSearch placeholder="Search here..." searchTableFunc={handleSearchStudentInvoice} />
                    )
                  }
                  />
                </div>
                <div className="page-content padding-equal margin-bottom-14">
                  <div className={classes.intro}>
                    <h4>
                        Audit Trail
                    </h4>
                  </div>
                  <Table data={searchAuditTransaction} columns={auditColumns} subHeader={true} pagination isLoading={isLoading} subHeaderComponent={
                    auditTransaction?.length > 0 && (
                      <TableSearch placeholder="Search here..." searchTableFunc={handleSearchAuditTransaction} />
                    )
                  }
                  />
                </div>
                <div className="page-content padding-equal margin-bottom-14">
                  <div className={`${classes.previewsubheader} text-align-left margin-top-16 `}>
                    <div>
                      <h4>Description:</h4>
                      <p>{invoice?.description || "--/--"}</p>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <Modal
            title="Cancel"
            subtitle={
              <div>
            Are you sure you want to cancel ?
              </div>
            }
            modalContent={<></>}
            modalFooter={
              <>
                <div className="flex gap-10">
                  <Button
                    variant="dangeroutline"
                    buttonSize="full"
                    color="btndanger"
                    buttonName="Go Back"
                    onClick={handleCloseCancelModal}
                  />
                  <Button
                    variant="danger"
                    buttonName="Yes, Cancel"
                    buttonSize="full"
                    color="btndefault"
                    onClick={() => navigate("/payment/overview")}
                  />
                </div>
              </>
            }
            isopen={cancelModal}
            closeModal={handleCloseCancelModal}
          />
          <Modal
            title="Payment Approval"
            subtitle="Please send to the immediately because you wont be able to see this password again"
            modalContent={
              <div className="margin-top-16">
                <Grid container spacing={2}>
                  <Grid item lg={4} md={4} sm={4} xs={6}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Payer's Name</p>
                        <h4>{`${approveItems?.payer?.last_name || "--/--"} ${approveItems?.payer?.first_name || "--/--"}`}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={6}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Payment Method</p>
                        <h4>{approveItems?.payment_method || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  {/* <Grid item lg={4} md={4} sm={4} xs={6}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Amount paid</p>
                        <h4>{approveItems?.structure_type || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid> */}
                  <Grid item lg={4} md={4} sm={4} xs={6}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Amount</p>
                        <h4>{approveItems?.amount || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Created On</p>
                        <h4>{approveItems?.created_at?.substring(0, 10) || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Updated On</p>
                        <h4>{approveItems?.updated_at?.substring(0, 10) || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <label className={classes.quelabel}>Comment <span className="input-required"> *</span></label>
                    <div className={classes.textandimg}>
                      <textarea
                        type="text"
                        placeholder="Enter comment"
                        name="comment"
                        onChange={handleCommentChange}
                      />
                    </div>
                  </Grid>
                </Grid>
              </div>
            }
            modalFooter={
              <>
                <Grid container spacing={2}>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Button
                      variant="danger"
                      buttonName="Decline"
                      buttonSize="full"
                      onClick={() => handleTransactionDecision("decline")}
                      isLoading={loadingDecision === "decline"}
                      color="btndefault"
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Button
                      variant="primary"
                      buttonName="Approve"
                      buttonSize="full"
                      onClick={() => handleTransactionDecision("approve")}
                      isLoading={loadingDecision === "approve"}
                      color="btndefault"
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Button
                      variant="primaryoutline"
                      buttonName="Request Info"
                      buttonSize="full"
                      onClick={() => handleTransactionDecision("request info")}
                      isLoading={loadingDecision === "request info"}
                      color="btnfontprimary"
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Button
                      variant="yellowOutline"
                      buttonName="Double Entry"
                      buttonSize="full"
                      onClick={() => handleTransactionDecision("double entry")}
                      isLoading={loadingDecision === "double entry"}
                      color="btnyellow"
                    />
                  </Grid>
                </Grid>
              </>
            }
            isopen={appoveModal}
            closeModal={handleApproveModal}
          />
          {/* Add a Transaction */}
          <Modal
            title="Add a Transaction"
            subtitle={
              <div>
                Manually record a payment received in cash for tuition, fees, or other charges.
              </div>
            }
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup
                      label="Payment Method"
                      required
                      children={
                        <select onChange={handleChange} name="payment_method">
                          <option value="">---Select Labels ---</option>
                          {PaymentMethod?.map((data) => {
                            return (
                              <option value={data.key} key={data?.key}>
                                {data?.text}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                    {addTransactionValidator.message("Payment Method", addTransaction?.payment_method, "required")}
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Reference"
                      margin="normal"
                      placeHolder="Add number"
                      inputType="nummber"
                      inputName="reference"
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Amount"
                      required
                      margin="normal"
                      placeHolder="Add amount"
                      inputType="nummber"
                      inputName="amount"
                      onChange={handleChange}
                    />
                    {addTransactionValidator.message("Amount", addTransaction?.amount, "required")}
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <label className={classes.quelabel}>Description <span className="input-required"> *</span></label>
                    <div className={classes.textandimg}>
                      <textarea
                        type="text"
                        placeholder="Enter description"
                        name="description"
                        onChange={handleChange}
                      />
                    </div>
                    {addTransactionValidator.message("Amount", addTransaction?.description, "required")}
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <p className="text-align-left no-margin-block">
                      <strong>Upload Image</strong>
                    </p>
                    <div className={classes.pickercontainers}>
                      <input
                        type="file"
                        required
                        multiple
                        className={classes.picker}
                        onChange={handleFileChange}
                        name="file"
                        accept="image/jpeg,image/jpg,image/png"
                      />

                      <div className={classes.uploadflex}>
                        <div>
                          <Icon
                            icon="icon-park-outline:upload-two"
                            className={classes.uploadicon}
                          />
                        </div>
                        {selectedFile?.length > 0 ? (
                          <div>
                            <p className={classes.uploadtitle}>Images Added</p>
                            <p className={classes.uploadsubtitle}>
                              {selectedFile.length} file{selectedFile.length > 1 ? "s" : ""} selected
                            </p>
                          </div>
                        ) : (
                          <div>
                            <p className={classes.uploadtitle}>Tap to Upload</p>
                            <p className={classes.uploadsubtitle}>SVG, PNG, JPG | 10MB max.</p>
                          </div>
                        )}
                      </div>
                      <div className={classes.rightpicker}>
                        {selectedFile?.name ? (
                          <div
                            className={classes.uploadbutton}
                            onClick={handleRemoveFile}
                          >
                            <Icon icon="zondicons:minus-solid" /> Remove File
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {/* {noticeValidator.message("file", selectedFile, "required")} */}
                    {selectedFile?.length > 0 && (
                      <Grid item lg={6} md={12} sm={12} xs={12}>
                        <div className={classes.previewGrid}>
                          {selectedFile.map((file, index) => {
                            const fileUrl = URL.createObjectURL(file);

                            return (
                              <div key={index} className={classes.previewItem}>
                                <img src={fileUrl} alt={`preview-${index}`} className={classes.previewImage} />
                                <div
                                  className={classes.removeBtn}
                                  onClick={() => handleRemoveFile(index)}
                                >
                                  <Icon icon="zondicons:minus-solid" /> Remove
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <Button
                  variant="primary"
                  buttonName="Add Transaction"
                  buttonSize="full"
                  color="btndefault"
                  onClick={handleCreateTransaction}
                  isLoading={addTransactionIsLoading}
                />
              </>
            }
            isopen={addTransactionModal}
            closeModal={handleTransactionModal}
          />
          <Modal
            title="Transaction Details"
            subtitle="See your transaction details here"
            modalContent={
              <div className="margin-top-16">
                <Grid container spacing={2}>
                  <Grid item lg={4} md={4} sm={4} xs={6}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Payer's Name</p>
                        <h4>{`${approveItems?.payer?.last_name || "--/--"} ${approveItems?.payer?.first_name || "--/--"}`}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={6}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Payment Method</p>
                        <h4>{approveItems?.payment_method || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  {/* <Grid item lg={4} md={4} sm={4} xs={6}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Amount paid</p>
                        <h4>{approveItems?.structure_type || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid> */}
                  <Grid item lg={4} md={4} sm={4} xs={6}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Amount</p>
                        <h4>{approveItems?.amount?.toLocaleString() || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Created On</p>
                        <h4>{approveItems?.created_at?.substring(0, 10) || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Updated On</p>
                        <h4>{approveItems?.updated_at?.substring(0, 10) || "--/--"}</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <label className={classes.quelabel}>Comment <span className="input-required"></span></label>
                    <div className={classes.textandimg}>
                      <textarea
                        type="text"
                        placeholder=""
                        name="description"
                        defaultValue={approveItems?.description || ""}
                        // onChange={handleChange}
                      />
                    </div>
                  </Grid>
                </Grid>
              </div>
            }
            modalFooter={
              <>
                {/* <Grid container spacing={2}>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Button variant="primaryoutline" buttonName="Send Receipts" buttonSize="full" color="btnfontprimary" />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Button variant="primary" buttonName="Download Receipts" buttonSize="full" color="btndefault" />
                  </Grid>
                </Grid> */}
              </>
            }
            isopen={paymentDetails}
            closeModal={handlePaymentDetails}
          />
          {/* <ToastContainer /> */}
        </>
      }
    />
  );
};

export default PreviewInvoice;
